import { Icon } from '@components/common/icons'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useState, useEffect } from 'react'
import { CClient } from '@common/utils'

const ProgressReportsHelloBar = () => {
  const { pathname } = useRouter()
  const [hasProgressReports, setHasProgressReports] = useState<boolean | null>(
    null
  )

  // Only show on student dashboard pages, but not on the progress reports page itself
  const isStudentDashboard = pathname.includes('/student/dashboard')
  const isProgressReportsPage =
    pathname === '/student/dashboard/progress-reports'
  const shouldShowOnPage = isStudentDashboard && !isProgressReportsPage

  useEffect(() => {
    if (!shouldShowOnPage) return

    const checkProgressReports = async () => {
      try {
        const response = await CClient('/api/v1/progress-reports/latest/')
        setHasProgressReports(response.status === 200)
      } catch (error) {
        setHasProgressReports(false)
      }
    }

    checkProgressReports()
  }, [shouldShowOnPage])

  // Don't show if we shouldn't show on this page or if student has no progress reports
  if (!shouldShowOnPage || !hasProgressReports) {
    return null
  }

  return (
    <div className="text-white bg-orange py-3 px-4 lg:px-6 shadow-sm text-center font-600">
      <div className="flex items-center justify-center max-w-7xl mx-auto">
        <div className="flex items-center space-x-3">
          <div className="flex-shrink-0">
            <Icon name="FileText" className="w-5 h-5 text-white" />
          </div>
          <div className="flex items-center space-x-2">
            <p className="text-sm lg:text-base">
              Check your latest progress report.
            </p>
          </div>
          <div className="flex items-center ml-2">
            <Link href="/student/dashboard/progress-reports">
              <a className="flex items-center space-x-1 underline">
                <span>View Reports</span>
                <Icon name="ArrowRight" className="w-4 h-4" />
              </a>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProgressReportsHelloBar
